import Axios from "axios";
import { useContext, useState } from "react";
import { Button, Col, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DashboardContext from "../../../Context";
import InputControl from "../../inputs/InputControl";

/**
 * این کامپوننت برای نمایش مدال پیگیری مالی نیرو در جدول سفارشات است
 */
export default function ModalDebtTracking({ showitem, handleCloseMoudal, id, handeldeleteitem }) {

    const { urldashboard, authentication } = useContext(DashboardContext);

    const [dataFrom, setDataFrom] = useState({})
    const [loading, setLoading] = useState(false)


    const handelValue = (name, value) => {
        switch (name) {
            case 'debtTrackingType':
                setDataFrom({ ...dataFrom, debtTrackingType: value, workerOrderScheduleId: id })
                break;
            case 'description':
                setDataFrom({ ...dataFrom, description: value })
                break;
            default:
                break;
        }
    }

    const handelsendData = async () => {
        try {
            const res = await Axios.post(`${urldashboard}/debttracking/create`, JSON.stringify(dataFrom), {
                headers: {
                    "Authorization": authentication,
                    "content-type": "application/json; charset=utf-8"
                }
            })
            const data = await res.data
            toast.success(data.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLoading(false)
            handleCloseMoudal()
        } catch (error) {

            if (error.message === 'Network Error') {
                toast.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setLoading(false)
            }
            else {
                setLoading(false)
                toast.error(error.response.data.message, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }


    const handelsubmit = () => {
        setLoading(true)

        if (dataFrom.debtTrackingType.length < 0) {
            toast.error('وارد کردن پیگیری اجباری است', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLoading(false)
        }
        else if (!dataFrom.description) {
            toast.error('وارد کردن توضیحات اجباری است', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLoading(false)
        }
        else {
            handelsendData()
        }
    }
    return (
        <Modal show={showitem} onHide={handleCloseMoudal}  >
            <Modal.Header>
            <Modal.Title>پیگیری مالی نیرو</Modal.Title>
            <i className="fa fa-times mr-auto" style={{fontSize:'16px',cursor:'pointer'}} onClick={handleCloseMoudal}  aria-hidden="true"></i>

            </Modal.Header>
            <Modal.Body >
                <Form>
                    <Form.Row>
                        <Col>
                            <InputControl url='/debttracking/debttrackingtypedropdown' label='نتیجه پیگیری' name='debtTrackingType' handelValue={handelValue} />
                        </Col>
                    </Form.Row>
                    <Form.Row>
                        <Col>
                            <div className="form-group">
                                <label for="descriptionTextarea">توضیحات</label>
                                <textarea className="form-control" id="descriptionTextarea" name='description' rows="6" onChange={(e) => handelValue('description', e.target.value)}></textarea>
                            </div>

                        </Col>
                    </Form.Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" disabled={loading} onClick={handleCloseMoudal}>
                    لغو
          </Button>
                <Button variant="success" disabled={loading} onClick={handelsubmit}>
                    {
                        loading ?
                            <i className="fa fa-spinner fa-pulse fa-fw"></i>

                            : "ثبت"
                    }
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
